// Section 7 — Live Jobs (Adzuna tie-in).
// NOTE TO AJAYE: these listings and the "1,200+" count are representative
// placeholders for the Fort Worth / Dallas area. Replace with real Adzuna pulls
// once that integration is wired into the marketing surface. Generic employer
// descriptors are intentional until then.
const JOBS = [
  {
    title: 'IT Support Specialist',
    employer: 'Regional MSP',
    location: 'Fort Worth, TX',
    salary: '$48,000 – $58,000',
    cert: 'CompTIA A+ preferred',
    posted: '2 days ago',
  },
  {
    title: 'Network Administrator',
    employer: 'Healthcare Network',
    location: 'Dallas, TX',
    salary: '$72,000 – $82,000',
    cert: 'Network+ required',
    posted: '5 days ago',
  },
  {
    title: 'Security Analyst (Entry-Level)',
    employer: 'Telecommunications Firm',
    location: 'Plano, TX',
    salary: '$78,000 – $92,000',
    cert: 'Security+ required',
    posted: '1 week ago',
  },
];

export default function LiveJobsSection() {
  return (
    <section className="lj-sec">
      <div className="lj-inner">
        <h2 className="lj-h2">Train toward jobs that are actually hiring.</h2>
        <p className="lj-sub">
          AdaptOS connects every lesson to the roles you&rsquo;re targeting &mdash;
          with live job listings pulled into your dashboard.
        </p>

        <div className="lj-cta">
          <a href="/registration" className="lj-cta-btn">Take A Look</a>
          <p className="lj-cta-note">
            No card required to sign up, feel free to browse around with no pressure.
          </p>
        </div>

        <div className="lj-grid">
          {JOBS.map(job => (
            <article className="lj-card" key={job.title}>
              <div className="lj-card-top">
                <div className="lj-logo" aria-hidden="true" />
                <span className="lj-posted">{job.posted}</span>
              </div>
              <h3 className="lj-title">{job.title}</h3>
              <p className="lj-employer">{job.employer}</p>
              <p className="lj-loc">📍 {job.location}</p>
              <p className="lj-salary">{job.salary}</p>
              <span className="lj-cert">{job.cert}</span>
            </article>
          ))}
        </div>

        <p className="lj-closing">
          <strong>1,200+ IT roles</strong> posted in your area this week. AdaptOS
          pulls live listings into your dashboard so you can train toward
          what&rsquo;s hiring.
        </p>
      </div>

      <style>{`
        .lj-sec {
          position: relative; z-index: 1;
          padding: clamp(48px, 8vh, 96px) clamp(16px, 4vw, 40px);
          border-top: 1px solid rgba(0,0,0,0.05);
          background:
            radial-gradient(120% 120% at 50% 0%, rgba(217,119,6,0.12) 0%, transparent 60%),
            rgba(0,0,0,0.02);
        }
        .lj-inner { max-width: 1100px; margin: 0 auto; }
        .lj-h2 {
          font-family: 'Fraunces', serif; font-weight: 500;
          font-size: clamp(28px, 4vw, 44px); line-height: 1.1;
          letter-spacing: -0.02em; margin: 0; text-align: center;
        }
        .lj-sub {
          font-weight: 300; color: rgba(17,17,16,0.62);
          font-size: clamp(16px, 2vw, 20px); line-height: 1.5;
          margin: 18px auto 0; max-width: 58ch; text-align: center;
        }
        /* Emerald CTA under the subhead — invites no-pressure browsing. */
        .lj-cta { margin: clamp(22px, 3vw, 32px) auto 0; text-align: center; }
        .lj-cta-btn {
          display: inline-flex; align-items: center; justify-content: center;
          background: #059669; color: #ffffff; text-decoration: none;
          font-size: 16px; font-weight: 700; letter-spacing: .01em;
          padding: 14px 30px; border-radius: 12px;
          box-shadow: 0 6px 22px rgba(5,150,105,0.28);
          transition: transform .18s ease, box-shadow .18s ease, background .18s ease;
        }
        .lj-cta-btn:hover { background: #047857; transform: translateY(-2px); box-shadow: 0 10px 30px rgba(5,150,105,0.38); }
        .lj-cta-note {
          font-size: 13px; color: rgba(17,17,16,0.5);
          margin: 12px auto 0; line-height: 1.5; max-width: 46ch;
        }
        .lj-grid {
          margin-top: clamp(32px, 5vw, 48px);
          display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px;
        }
        .lj-card {
          background: #ffffff; box-shadow: 0 4px 20px rgba(0,0,0,0.05);
          border: 1px solid rgba(0,0,0,0.08); border-radius: 16px;
          padding: 22px; display: flex; flex-direction: column; gap: 6px;
          transition: border-color .2s ease, transform .2s ease;
        }
        .lj-card:hover { border-color: rgba(217,119,6,0.30); transform: translateY(-3px); }
        .lj-card-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px; }
        .lj-logo {
          width: 42px; height: 42px; border-radius: 10px;
          background: linear-gradient(135deg, rgba(217,119,6,0.25), rgba(217,119,6,0.18));
          border: 1px solid rgba(0,0,0,0.10);
        }
        .lj-posted { font-size: 12px; color: rgba(17,17,16,0.4); }
        .lj-title { font-size: 17px; font-weight: 700; color: #111110; margin: 0; line-height: 1.3; }
        .lj-employer { font-size: 14px; color: rgba(17,17,16,0.7); margin: 0; }
        .lj-loc { font-size: 13px; color: rgba(17,17,16,0.55); margin: 2px 0 0; }
        .lj-salary { font-size: 19px; font-weight: 700; color: #059669; margin: 8px 0 0; font-variant-numeric: tabular-nums; }
        .lj-cert {
          align-self: flex-start; margin-top: 10px;
          font-size: 12px; font-weight: 600; color: rgba(17,17,16,0.78);
          background: rgba(0,0,0,0.05); border: 1px solid rgba(0,0,0,0.10);
          padding: 5px 11px; border-radius: 99px;
        }
        .lj-closing {
          margin: clamp(28px, 5vw, 44px) auto 0; text-align: center;
          font-size: clamp(15px, 1.9vw, 18px); line-height: 1.6;
          color: rgba(17,17,16,0.68); max-width: 60ch; font-weight: 300;
        }
        .lj-closing strong { color: #111110; font-weight: 700; }
        @media (max-width: 820px) {
          .lj-grid { grid-template-columns: 1fr; max-width: 460px; margin-left: auto; margin-right: auto; }
        }
      `}</style>
    </section>
  );
}
